(function (window, $) {
  'use strict';
  var document = window.document;

  var sliders = {
    init: function () {
      const _this = this;

      // Slider actualités (avec range)
      $('.slider-listing__actualite').each(function () {
        const id = $(this).attr('id');
        const count = $(this).children().length;

        $(this).slick({
          slidesToShow: 3,
          swipeToSlide: true,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: false,
          arrows: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        _this.addSlideRange(id);
        _this.addStyles(id, count);
      });

      $('.single-publication__slider').each(function () {
        const id = $(this).attr('id');

        $(this).slick({
          slidesToShow: 4,
          swipeToSlide: true,
          autoplay: false,
          dots: false,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        _this.addSlideRange(id);
      });

      // Slider actualités
      $('.slider__actualite').each(function () {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: true,
          arrows: true,
          fade: true,
          infinite: false,
          cssEase: 'linear',
          adaptiveHeight: true,
        });
      });

      // Slider actualités
      $('.slider__images').each(function () {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: true,
          arrows: true,
          fade: false,
          infinite: true,
          cssEase: 'linear',
          adaptiveHeight: false,
        });
      });

      // Slider capsules
      $('.slider-listing__capsules').each(function () {
        const id = $(this).attr('id');
        const count = $(this).children().length;

        $(this).slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: false,
          arrows: false,
          swipeToSlide: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
          ],
        });

        _this.addSlideRange(id);
        _this.addStyles(id, count);
      });

      _this.resize();
      _this.bindListeners();
    },

    bindListeners: function () {
      const _this = this;
      window.addEventListener('resize', _this.debounce(_this.resize).bind(_this));
    },

    addSlideRange: function (id, max) {
      $('#' + id).on('afterChange', function () {
        $('#slider-' + id + ' .sliderange').val($('#' + id).slick('slickCurrentSlide'));
      });

      $('#slider-' + id + ' .sliderange').on('input change', function () {
        $('#' + id).slick('slickGoTo', $(this).val());
      });

      if (max) $('#slider-' + id + ' .sliderange').attr('max', max);
    },

    addStyles: function (id, total, slidesToShow) {
      let count;

      if (!slidesToShow) count = total;
      else count = Math.ceil(total - slidesToShow) >= 0 ? Math.ceil(total - slidesToShow) + 1 : 1;

      const style = document.createElement('style');
      style.setAttribute('id', 'style-slider-' + id);

      let styleString = '#slider-' + id + ' .sliderange::-webkit-slider-thumb { width: calc(100% / ' + count + '); }';
      styleString += '#slider-' + id + ' .sliderange::-moz-range-thumb { width: calc(100% / ' + count + '); }';

      style.textContent = styleString;
      document.head.append(style);

      $('#slider-' + id + ' .slick-dots li, #slider-' + id + ' .slick-dots li.slick-active').css(
        'width',
        'calc(100% / ' + total + ')'
      );
    },

    debounce(fn, time = 150) {
      let timer;
      return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(fn.bind(this), time, event);
      };
    },

    resize: function () {
      const _this = this;

      $('.single-publication__slider').each(function () {
        const id = $(this).attr('id');
        const total = $('#slider-' + id + ' .sliderange').data('count');
        let slidesToShow;

        if (window.matchMedia('(max-width: 576px)').matches) {
          slidesToShow = 1;
        } else if (window.matchMedia('(max-width: 1200px)').matches) {
          slidesToShow = 2;
        } else if (window.matchMedia('(max-width: 1400px)').matches) {
          slidesToShow = 3;
        } else {
          slidesToShow = 4;
        }

        const max = Math.ceil(total - slidesToShow) >= 0 ? Math.ceil(total - slidesToShow) : 1;
        $('#slider-' + id + ' .sliderange').attr('max', max);

        $('#style-slider-' + id).remove();
        _this.addStyles(id, total, slidesToShow);
      });
    },
  };

  $(document).ready(function () {
    sliders.init();
    setTimeout(function () {
      $('.slick-initialized').slick('setPosition');
    }, 500);

    $(document).on('_page_loaded', function () {
      sliders.init();
      setTimeout(function () {
        $('.slick-initialized').slick('setPosition');
      }, 500);
    });
  });
})(window, $);
